import { NPIStatus } from "@app/projects/enumerators";

export function valueOrDashes(value: string | NPIStatus | boolean | number, numberAsCurrency?: boolean): React.ReactNode {
  let result: React.ReactNode = value;
  if (typeof result === "boolean") {
    result = result === undefined
      ? null
      : value
        ? "Y"
        : "N";
  }
  if (numberAsCurrency && (typeof result === "number")) {
    result = result
      ? `$${result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      : result;
  }

  return result || (<>---</>);
}
